import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination, TableRow, Hidden } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import DataTable from '../../components/DataTable/DataTable';
import AuditLogSearchForm from '../../components/AuditLogSearchForm/AuditLogSearchForm';
import TableCell from '../../components/DataTable/TableCell';


const propTypes = {
  paginate: PropTypes.bool,
  showEmptyRows: PropTypes.bool,
  search: PropTypes.bool,
  defaultLimit: PropTypes.number,
};

const defaultProps = {
  paginate: false,
  search: false,
  showEmptyRows: false,
  defaultLimit: 50,
};

class AuditLogTable extends React.Component {
  constructor(props) {
    super(props);
    const { defaultLimit } = this.props;
    this.state = {
      data: [],
      limit: defaultLimit,
      filters: { order_by: '-created_at' },
      total: 0,
      page: 0,
    };
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.renderRows = this.renderRows.bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  static getTableHeader() {
    return [
      { id: 1, label: 'Logged User' },
      { id: 2, label: 'Affected User', hidden: { xsDown: true } },
      { id: 3, label: 'Action' },
      { id: 4, label: 'Date' },
      { id: 5, label: 'IP Address', hidden: { smDown: true } },
    ];
  }

  async fetchData(searchFilters = null) {
    const { auditLogStore, loadingStore } = this.props;
    loadingStore.setReady(false);
    const { page, limit, filters } = this.state;
    const offset = limit * page;
    const newFilters = searchFilters || filters;
    const params = Object.assign({ offset, limit }, newFilters);
    try {
      const auditLog = await auditLogStore.api.audits.get({ params });
      this.setState({
        data: auditLog.objects,
        filters: newFilters,
        total: auditLog.meta.total_count,
      });
    } catch (error) {
      this.setState({
        data: [],
        filters: newFilters,
      });
    }
    loadingStore.setReady(true);
  }

  handleChangePage(event, page) {
    this.setState({ page }, () => this.fetchData());
  }

  handleChangeRowsPerPage(event) {
    this.setState({ limit: event.target.value }, () => this.fetchData());
  }

  renderRows() {
    const { data } = this.state;
    return data.map(row => (
      <TableRow hover tabIndex={-1} key={row.id}>
        <TableCell component="th" scope="row" padding="default">
          {row.logged_user}
        </TableCell>
        <Hidden xsDown>
          <TableCell>
            {row.affected_user}
          </TableCell>
        </Hidden>
        <TableCell>
          {row.action}
        </TableCell>
        <TableCell>
          {moment(row.created_at).format('MMM DD, YYYY hh:mm:ss a')}
        </TableCell>
        <Hidden smDown>
          <TableCell>
            {row.ip_address}
          </TableCell>
        </Hidden>
      </TableRow>
    ));
  }

  renderPagination() {
    const { total, limit, page } = this.state;
    const { defaultLimit } = this.props;
    let rowsPerPageOptions = [5, 10, 25];
    if (defaultLimit > 10) {
      rowsPerPageOptions = [25, 50, 75];
    }
    return (
      <TablePagination
        component="div"
        count={total}
        rowsPerPage={limit}
        rowsPerPageOptions={rowsPerPageOptions}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        onChangePage={this.handleChangePage}
        onChangeRowsPerPage={this.handleChangeRowsPerPage}
      />
    );
  }

  renderSearch() {
    return <AuditLogSearchForm onSubmit={this.fetchData} />;
  }

  render() {
    const { data, limit, page } = this.state;
    const { paginate, search, showEmptyRows } = this.props;
    let emptyRows = 0;
    if (showEmptyRows) {
      emptyRows = limit - Math.min(limit, data.length - page * limit);
    }
    const searchComponent = search ? this.renderSearch() : null;
    return (
      <div>
        {searchComponent}
        <DataTable
          header={AuditLogTable.getTableHeader()}
          renderRows={this.renderRows}
          emptyRows={emptyRows}
          paginate={paginate}
          renderPagination={this.renderPagination}
        />
      </div>
    );
  }
}

AuditLogTable.propTypes = propTypes;
AuditLogTable.defaultProps = defaultProps;
export default inject('auditLogStore', 'authStore', 'snackbarStore', 'loadingStore')(
  observer(AuditLogTable),
);



// WEBPACK FOOTER //
// ./src/containers/AuditLogTable/AuditLogTable.js